module.exports = __webpack_public_path__ + "static/img/琵琶.8deb13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/琵琶.png
// module id = yUdf
// module chunks = 4